import { Component, OnInit ,Input,Output,EventEmitter} from '@angular/core';

@Component({
  selector: 'app-gestiones-infoparticipante',
  templateUrl: './gestiones-infoparticipante.component.html',
  styleUrls: ['./gestiones-infoparticipante.component.scss']
})
export class GestionesInfoparticipanteComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() selectParticipante = new EventEmitter<number>();
  @Input() gestionSeleccionada: any
  @Input() participante: any
  @Input() datacliente: any
  constructor() { 
  }

  ngOnInit(): void {

  }
  selectedtab(tab) {
    this.selecttab.emit(tab)
  }
  selectedparticipante(item) {
    this.selectParticipante.emit(item)
  }
}
